<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">Name Kh </label>
        <input
          ref="division_name_kh"
          v-model="model.division_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('division_name_kh') }"
          placeholder="Enter name kh"
        />
        <div class="invalid-feedback" v-if="errors.has('division_name_kh')">
          {{ errors.first('division_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">Name En <span class="text-danger">*</span> </label>
        <input
          v-model="model.division_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('division_name_en') }"
          placeholder="Enter name en"
        />
        <div class="invalid-feedback" v-if="errors.has('division_name_en')">
          {{ errors.first('division_name_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"> Description </label>
        <textarea
          v-model="model.division_description"
          class="form-control"
          :class="{
            'is-invalid': errors.has('division_description')
          }"
          rows="3"
          placeholder="Description..."
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('division_description')">
          {{ errors.first('division_description') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          Cancel
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          Update
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          Save
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'division-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        division_name_kh: '',
        division_name_en: '',
        division_description: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.division_name_kh.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('success_update')
      this.$router.push({ name: 'division' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('administration/division/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.division_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('administration/division/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'division' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.division_name_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.division_name_kh = ''
      this.model.division_name_en = ''
      this.model.division_description = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
